import React, { Component } from "react"
import styled from "styled-components"

class BoxTwo extends Component {
  render() {
    return (
      <MainBox>
        <Box>
          <BoxHeader>Put manual tasks on Autopilot</BoxHeader>
        </Box>
      </MainBox>
    )
  }
}
export default BoxTwo

const MainBox = styled.div`
  background: #2a1e5c;

  display: grid;
  justify-content: center;
  align-content: center;
  /* @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  } */
`
const Box = styled.div`
  text-align: center;
  height: 50vh;
  width: 50vw;
  display: grid;
  justify-content: center;
  align-content: center;
`
const BoxHeader = styled.h2`
  font-family: "Roboto";
  font-weight: 500;
  font-size: 2.75em;
  text-align: center;
  color: #ffffff;
`
